import { render, staticRenderFns } from "./factoryInfo.vue?vue&type=template&id=1c3159d6&scoped=true"
import script from "./factoryInfo.vue?vue&type=script&lang=js"
export * from "./factoryInfo.vue?vue&type=script&lang=js"
import style0 from "./factoryInfo.vue?vue&type=style&index=0&id=1c3159d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3159d6",
  null
  
)

export default component.exports